<template>
  <!-- From payment consolidate Create Payout Button Launch Modal -->
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="600px">
      <v-card>
        <v-card-title class="pb-5" style="padding-left: 45px;">
          <span class="headline">{{disableEdit ? 'Edit' : 'Create'}} COGS Estimation</span>
        </v-card-title>
        <v-card-text style="padding: 0px 50px;">
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-combobox
                :items="campaigns"
                :search-input.sync="search"
                hide-details="auto"
                item-text="displayName"
                @blur="$v.payout.campaign.$touch()"
                :error-messages="selectedCampaignErrors"
                @change="changeCampaign()"
                v-model="payout.campaign"
                v-if="!payout.id"
                label="IO or Campaign"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ search }}</strong
                        >". Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
              <v-row v-if="payout.id && payout.campaign">
                <v-col class="pb-0" cols="12" md="6" sm="12">
                  <p class="title-1 form-label">Campaign : </p>
                </v-col>
                <v-col class="pb-0" cols="12" md="6" sm="12">
                  <p class="body-2 mb-0">{{payout.campaign.ioNumbers}} - {{payout.campaign.name}}</p>
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-col cols="12" md="6" sm="12">
              <v-combobox
                :items="influencers"
                item-text="handle"
                hide-details="auto"
                v-model="payout.handle"
                label="Influencers"
                prefix="@"
                dense
                outlined
              >
              </v-combobox>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Incurred Date (DD/MM/YYYY) : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-text-field
                v-model="payout.live_date"
                v-on="on"
                dense
                outlined
                hide-details="auto"
                :disabled="disableEdit"
                @blur="$v.payout.live_date.$touch()"
                @input="changeLiveDate"
                @keyup.enter="changeLiveDate"
              ></v-text-field>
              <span class="custom-danger ma-0 pt-1" v-if="isInvalidLiveDate">Invalid Incurred Date</span>
              <span class="custom-danger ma-0 pt-1" v-if="!isInvalidLiveDate && !payout.live_date">This field is required</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Creator Handle : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-combobox
                v-if="!disableEdit"
                :items="influencers"
                item-text="handle"
                hide-details="auto"
                v-model="payout.handle"
                label="Influencers"
                prefix="@"
                dense
                outlined
              >
                <template v-slot:item="{ item }">
                  <social-handle-view
                    divClassName="d-inline"
                    :isTikTok="item.platform === 'tiktok'"
                    :isInstagram="!item.platform || item.platform === 'instagram'"
                    :isYoutube="item.platform === 'youtube'"
                    :isFacebook="item.platform === 'facebook'"
                    :isXiaohongshu="item.platform === 'xiaohongshu'"
                    :tiktokHandle="item.handle"
                    :instagramHandle="item.handle"
                    :youtubeHandle="item.handle"
                    :facebookHandle="item.handle"
                    :xiaohongshuHandle="item.handle"
                  />
                </template>
              </v-combobox>
              <p class="subtitle-1 mb-0" v-if="disableEdit && payout.handle">{{payout.handle.handle}}</p>
              <p class="subtitle-1 mb-0" v-if="disableEdit && !payout.handle">-</p>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Type : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-select
                :items="estimationTypes"
                label="Type"
                v-model="payout.estimationType"
                @blur="$v.payout.estimationType.$touch()"
                :error-messages="estimationTypeErrors"
                dense
                outlined
                hide-details="auto"
              ></v-select>
              <v-text-field
                v-if="payout.estimationType === 'Others'"
                class="mt-2"
                v-model="payout.customType"
                placeholder="Custom"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Amount : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-text-field
                type="number"
                v-model="payout.amount"
                :disabled="disableEdit"
                @blur="$v.payout.amount.$touch()"
                :error-messages="amountErrors"
                placeholder=""
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
<!-- 
          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Campaign - COGS-related : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-text-field
                type="number"
                v-model="payout.cogsRelated"
                placeholder=""
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Internal Claims - COGS : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-text-field
                type="number"
                v-model="payout.internalClaims"
                placeholder=""
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Logistics : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-text-field
                type="number"
                v-model="payout.logistics"
                placeholder=""
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Other Adjustment : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-text-field
                type="number"
                v-model="payout.otherAdjustment"
                placeholder=""
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <p class="title-1 form-label">Remarks : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="12">
              <v-textarea
                hide-details
                v-model="payout.remarks"
                :disabled="disableEdit"
                dense
                outlined
                style="width:100%"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pb-0" cols="12" md="12" sm="12">
              <custom-file-upload
                title="Upload Invoices"
                :refresh="fileUploadRefresh"
                :multiple="true"
                @setMedias="updateInvoices"
              />
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model="payout.live_date"
                v-on="on"
                dense
                outlined
                label="Incurred Date (DD/MM/YYYY)"
                hide-details="auto"
                :disabled="disableEdit"
                @blur="$v.payout.live_date.$touch()"
                @input="changeLiveDate"
                @keyup.enter="changeLiveDate"
              ></v-text-field>
              <span class="custom-danger ma-0 pt-1" v-if="isInvalidLiveDate">Invalid Incurred Date</span>
              <span class="custom-danger ma-0 pt-1" v-if="!isInvalidLiveDate && !payout.live_date">This field is required</span>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Amount"
                type="number"
                v-model="payout.amount"
                :disabled="disableEdit"
                @blur="$v.payout.amount.$touch()"
                :error-messages="amountErrors"
                placeholder="300"
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Campaign - COGS-related"
                type="number"
                v-model="payout.cogsRelated"
                placeholder="100"
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Internal Claims - COGS"
                type="number"
                v-model="payout.internalClaims"
                placeholder="100"
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Logistics"
                type="number"
                v-model="payout.logistics"
                placeholder="100"
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Other Adjustment"
                type="number"
                v-model="payout.otherAdjustment"
                placeholder="100"
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-textarea
                hide-details
                label="Remarks"
                v-model="payout.remarks"
                :disabled="disableEdit"
                dense
                outlined
                style="width:100%"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <custom-file-upload
                :refresh="fileUploadRefresh"
                :multiple="true"
                @setMedias="updateInvoices"
              />
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="green darken-1" :disabled="disableSavePayout" text @click="savePayout">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-row>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import campaignAPIs from '../../Campaign/campaignAPIs';
import clientAPIs from '../../Client/clientAPIs';
import pairingAPIs from '../../Pairing/pairingAPIs';
import config from '@/config';
import { mapState, mapGetters } from 'vuex';
import Loading from 'vue-loading-overlay';
import CustomFileUpload from '@/components/scoped/custom/CustomFileUpload';
import SocialHandleView from '@/components/scoped/custom/SocialHandleView'
// import moment from 'moment'
export default {
  name: 'CreateCogsEstimateModal',
  components: {
    Loading,
    CustomFileUpload,
    SocialHandleView
  },
  mixins: [validationMixin],
  props: {
    value: Boolean,
    editItem: Object
  },
  validations: function() {
    return this.rules
  },
  data() {
    return {
      estimationTypes: [
        'Loading/Boosting Fee',
        'Ad Expenses',
        'Logistics',
        'Others'
      ],
      payout: {
        handle: null,
        campaign: null,
        live_date: '',
        amount: '',
        remarks: '',
        estimationType: '',
        duplicate: false
      },
      pickDate: false,
      search: null,
      searchCs: null,
      campaigns: [],
      clients: [],
      influencers: [],
      searchClient: null,
      isLoading: false,
      isInvalidLiveDate: false,
      unPaidAmtErr: false,
      invoiceFiles: [],
      fileUploadRefresh: 1
    };
  },
  computed: {
    ...mapState({
      paymentStatuses: state => state.payment.status
    }),
    ...mapGetters('payment', [
      'allowedStatuses',
      'allowedStatusesForPayoutCreate'
    ]),
    rules() {
      const validationRules = {
        payout: {
          campaign: {
            required
          },
          live_date: {
            required
          },
          estimationType: {
            required
          },
          amount: {
            required
          }
        }
      }
      return validationRules
    },
    selectedCampaignErrors() {
      const errors = [];
      if (!this.$v.payout.campaign.$dirty) return errors;
      !this.$v.payout.campaign.required && errors.push(' This field is required.');
      return errors;
    },
    estimationTypeErrors() {
      const errors = [];
      if (!this.$v.payout.estimationType.$dirty) return errors;
      !this.$v.payout.estimationType.required && errors.push('This field is required.');
      return errors;
    },
    amountErrors() {
      const errors = [];
      if (!this.$v.payout.amount.$dirty) return errors;
      !this.$v.payout.amount.required && errors.push('This field is required.');
      return errors;
    },
    liveDateErrors() {
      const errors = [];
      if (!this.$v.payout.live_date.$dirty) return errors;
      !this.$v.payout.live_date.required && errors.push('This field is required.');
      return errors;
    },
    currentUserID: function () {
      return this.$store.state.user.id;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    campaignStatus() {
      return Object.values(config.campaignStatus).join();
    },
    disableSavePayout() {
      return this.$v.payout.$invalid || this.unPaidAmtErr || this.isInvalidLiveDate
    }
    // disableEdit() {
    //   if (this.editItem && this.editItem.id) {
    //     return true
    //   }
    //   return false
    // }
  },
  watch: {
    value: function (newValue) {
      this.disableEdit = false
      this.payout.campaign = null
      this.resetForm()
    },
    editItem: async function (newValue) {
      if (!newValue) {
        delete this.payout.id
        return
      }
      let matchCampaign = this.campaigns.find(campaign => campaign.id === newValue.campaignID)
      if (matchCampaign) {
        this.payout.id = newValue.id
        this.payout.campaign = matchCampaign
        this.payout.live_date = this.formatDate(newValue.liveDate)
        this.payout.amount = newValue.amount
        this.payout.remarks = newValue.remarks
        this.payout.estimationType = newValue.estimationType || ''
        this.payout.customType = newValue.customType || ''
        if (!newValue.created) {
          this.disableEdit = true
        }
        await this.changeCampaign()
        if (newValue.handle) {
          let matchInf = this.influencers.find(i => i.handle === newValue.handle)
          if (matchInf) {
            this.payout.handle = Object.assign({}, matchInf)
          }
        }
      }
    }
  },
  mounted() {
    this.fetchCampaigns();
    this.fetchClient();
  },
  methods: {
    close() {
      this.$emit('input');
    },
    async savePayout() {
      try {
        this.isLoading = true;
        const formData = this.constructData(this.payout);
        await this.$store.dispatch('payment/createCogsEstimate', formData)
        this.isLoading = false;
        this.$emit('created');
        this.$emit('input');
        this.$swal({
          text: this.payout.id ? 'Successfully updated COGS Estimation' : 'New COGS Estimation is created',
          type: 'success'
        });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        this.$swal({
          text: error.message,
          type: 'error'
        });
      }
    },
    async fetchCampaigns() {
      try {
        const resp = await campaignAPIs.getAllCampaigns(this.campaignStatus, false);
        const data = resp.data;
        const campaigns = data.campaigns;
        this.campaigns = campaigns.map(cmp => {
          return {
            displayName: cmp.ioNumbers ? `${cmp.ioNumbers} - ${cmp.name}` : cmp.name,
            name: cmp.name,
            id: cmp.id,
            ioNumbers: cmp.ioNumbers,
            assignedTo: cmp.assignedTo,
            clientID: cmp.clientID
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of campaigns',
          icon: 'error'
        });
      }
    },
    filterClientByCampaigns(clientID) {
      const client = this.clients.find(cmp => cmp.id === clientID);
      return client;
    },
    constructData(input) {
      let formData = new FormData();
      let saveData = {
        handle: input.handle ? input.handle.handle : null,
        platform: input.handle ? input.handle.platform : null,
        username: input.handle ? input.handle.username : null,
        campaign: {
          id: input.campaign.id,
          name: input.campaign.name,
          clientName: input.client.name,
          IONumber: input.campaign.ioNumbers,
          POC: input.campaign.assignedTo
        },
        pairedAmount: input.handle ? Number(input.handle.amount) : 0,
        amount: Number(input.amount),
        estimationType: input.estimationType,
        customType: input.customType,
        liveDate: this.parseDate(input.live_date),
        remarks: input.remarks
      }
      if (input.id) {
        saveData.id = input.id
      }
      formData.append('data', JSON.stringify(saveData))
      for (let val of this.invoiceFiles) {
        formData.append('isInvoice', true)
        formData.append('uploadFile', val)
      }
      return formData;
    },
    async changeCampaign() {
      // this.resetForm()
      let newValue = this.payout.campaign
      if (newValue && newValue.clientID) {
        this.payout.client = this.filterClientByCampaigns(newValue.clientID);
      }
      if (newValue && newValue.name) {
        try {
          // get pairing influencers
          const resp = await pairingAPIs.getPairedInfluencersByCampaign(newValue.id)
          this.setInfluencers(resp)
        } catch (error) {
          console.log(error);
          this.$swal({
            text: 'Cannot fetch the list of Influencers',
            icon: 'error'
          });
        }
      }
    },
    setInfluencers(resp) {
      resp = resp.filter(r => {
        if (r.pairing_details && r.pairing_details.status) {
          if (r.pairing_details.status === config.pairingStatus.ACCEPTED) {
            return true
          }
        }
        return false
      })
      this.influencers = resp.map(pairing => {
        if (pairing.influencer_details) {
          let influencerDetails = pairing.influencer_details
          let payoutDetails = pairing.payout_details
          let respData = Object.assign({}, {
            campaignID: pairing.campaignID,
            influencerID: influencerDetails.influencerID || '',
            handle: influencerDetails.instagramHandle,
            username: influencerDetails.fullname || '',
            platform: influencerDetails.platform || 'instagram',
            amount: payoutDetails.amount || 0
          })
          if (respData.platform === 'xiaohongshu') {
            respData.handle = influencerDetails.fullName
          }
          return respData
        }
      })
    },
    async fetchClient() {
      try {
        const resp = await clientAPIs.getAllClients(true);
        const clients = resp.data;
        this.clients = clients.map(user => {
          return {
            name: user.name,
            id: user.id
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of clients',
          icon: 'error'
        });
      }
    },
    resetForm() {
      this.payout.handle = null
      this.payout.live_date = ''
      this.payout.amount = ''
      this.payout.estimationType = ''
      this.payout.customType = ''
      this.influencers = []
      this.invoiceFiles = []
      this.fileUploadRefresh += 1
    },
    updateInvoices(medias) {
      this.invoiceFiles = Object.assign([], medias)
    },
    changeLiveDate() {
      this.$v.payout.live_date.$touch()
      this.isInvalidLiveDate = false
      this.payout.due_date = ''
      if (!this.isDateValid(this.payout.live_date)) {
        this.isInvalidLiveDate = true
        return;
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      let formattedDate = `${day}/${month}/${year}`
      if (formattedDate.includes('undefined')) {
        return date
      }
      return formattedDate;
    },
    isDateValid(givenDate) {
      if (!givenDate) return true
      let regex = config.regexPattern.date_format
      if (givenDate.match(regex)) return true
      return false
    }
  }
};
</script>
<style scoped>
  .custom-danger {
    color: #ff5252 !important;
    font-size: 12px;
  }
  .form-label {
    margin-bottom: 0;
    font-size: 15px;
    font-weight: bold;
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// CreateCogsEstimateModal.vue?3061a603